export default "__VITE_ASSET__Dcrp4U$v__"